export enum ShiftTypeEnum {
  Regular = 'Regular',
  OnCall = 'OnCall',
  Urgent = 'Urgent',
  TemporaryContract = 'TemporaryContract'
}

export const SHIFT_TYPE_ENUM_RECORD: Record<ShiftTypeEnum, string> = {
  [ShiftTypeEnum.Regular]: 'Regular',
  [ShiftTypeEnum.OnCall]: 'OnCall',
  [ShiftTypeEnum.Urgent]: 'Urgent',
  [ShiftTypeEnum.TemporaryContract]: 'TemporaryContract'
};
